<template>
    <div class="card-body">
        <div class="habit-page">
            <div class="row mt-2">
                <div class="col-lg-11 col-11 mx-auto">
                    <div class="card card-widget widget-user">
                        <div class="widget-user-header text-white"
                                    style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                            <h2 class="widget-user-username text-left">How am I acting on the Plan.</h2>
                            <h2 class="widget-user-desc text-right">For Version 2.0 of You.</h2>
                            <h3 class="widget-user-username text-right">The power of Consistent Action.</h3>
                        </div>
                        <div class="widget-user-image">
                            <img class="img-circle" src="/assets/images/artist128x128.png" alt="User Avatar">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="list-group-item">
            <div class="row text-center col-4  mx-auto float-center" >
                <div class="content-box-gray card title text-center" >

                        <h3 class="title text-center" >Last Quarter Self-Evaluated  Effort</h3>

                    <div class="content">
                        <div class="card" style="padding:.5em;">
                        <canvas id="selfEvaluatedEffort"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
           <div class="card card-primary col-sm-12 col-12 mx-auto">
              <div class="card-header">
                <h5 class="card-title text-center">Your Last Quarter Effort</h5>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="chart">
                <div class="chart-container" style="position: relative; height:30vh; width:40vw;">
                    <canvas class="mx-auto" id="selfEvaluatedEffort" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>
                </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>


        <div class=" content modal-body">
          <!-- <div class="embed-responsive"> embed-responsive-16by9 -->
            <div class="card mx-auto col-10" style="background: #fff; border:3px solid #fff; ">
                <h5 class="text-center"  >Your Overall Future-Self (Weighted) Streak: </h5>
<div  class="card col-8 mx-auto p-2 mt-2 d-flex justify-content-center svg-container">
                <svg   style="margin:auto;" v-html="overallFSSVG" width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">
                </svg>
</div>
            </div>

            <div  class="card col-10 mx-auto" style="background: #e8f2e3;" v-if="lifeAreas.length>0 && lifeAreaDOYs">
                <h5  class="header-box-msg  text-center">Your Self-Evaluated Performance on your Future-Self Life-Areas:</h5>
                <div  v-if="lifeAreaSVGData" class="card col-8 mx-auto p-2 mt-2 d-flex justify-content-center svg-container">
                    <h6 class="text-center"> <b>Life-Area:</b><br/><em>{{currentLifeAreaDOY[0]}}</em></h6>
<!-- width="100%" height="100%" style="display:inline-block;margin:auto;" -->
                    <svg    v-html="lifeAreaSVGData" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    </svg>
                    {{LESSMORE}}
                </div>

                <div class="row d-flex justify-content-between" >
                    <div class="col-sm-4 col-md-2 bordered"  v-for="lifearea in lifeAreas" :key="lifearea.life_area">
                        <h4 >{{lifearea.life_area}}</h4>
                        <div class="color-palette-set">
                            <button class="btn btn-warning btn-sm mb-2"  @click="displayLifeAreaDOYSVG(lifearea.life_area)">Display My Performance <i class="fas fa-eye fai-blue"></i></button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '../../event-bus';
import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
import Chart from 'chart.js';
import svgbase from '../global/shared/svgbase';
import {LESSMORE} from '../global/shared/svgbase';
import { transparentize} from '../../chart/ChartUtils';
var _ = require('lodash');
// import Chart from 'chart.js';
export default {
    components: { Errors, },
    name: "FutureMeHabitResults",
    data() {
        return {
            userData:[],
            currentlifearea:'',
            currentlifeareadata:[],
            currentlifeareadoy:[],

            lifeAreaSVGData:'',

            allhabitsdata:[],
            overallLifeareaSVG:'',
            overallFSDOYKeys:'',
            currentLifeAreaDOYKeys:'',
            overallLifeAreaSVG:'',

            lifeAreaDOYs:'',
            lifeAreaDOYArray:[],
            chartData:'',


            lifeAreas: '',
            lifeAreasDOYs:'',
            overallFSDOY:'',
            overallFSDOYKeys:'',
            overallFSDOYVals:'',
            overallFSSVG:'',

            currentLifeAreaDOY:'',
            currentLifeAreaDOYKeys:'',
            currentLifeAreaDOYVals:'',
            currentLifeareaMultiplier:'',
            currentLifeAreaDOYValsMax:'',
            currentLifeAreaDOYValsMin:'',

            // overallFSSVG:'',
            // overallfspointssorted: '',
            overallFSMultiplier:'',
            overallFSDOYValsMax:'',
            overallFSDOYValsMin:'',

            MAX: 'MAX',
            MIN: 'MIN',
            VALS: 'VALS',
            KEYS: 'KEYS',


        }
    },
    props: {
        userdata:'',
        lifeareadoys: '',
        fselfdoy: '',
        lifeareas: '',
        chartdata:'',
        overallfsdoys:'',

    },
    mounted() {
        // console.error("FSMeResults mounting...");
        this.userData = JSON.parse(this.userdata);
        this.lifeAreas = JSON.parse(this.lifeareas);
        // this.overallFselfDOY = JSON.parse(this.fselfdoy);
        this.lifeAreaDOYs = JSON.parse(this.lifeareadoys);
        this.chartData = JSON.parse(this.chartdata);
        this.overallFSDOY = JSON.parse(this.overallfsdoys);

        this.getDOYKeysVals(this.overallFSDOY);
        this.componentPointsLayers() ;
        this.overallFSSVG =  this.createOverallFSDOYSVG2(this.overallFSDOY, this.overallFSDOYKeys, this.overallFSDOYValsMin, this.overallFSMultiplier, 'blue') ;

        this.displayCharts();
        // console.error("FSMeResults mounted.");
    },
    methods: {
        displayLifeAreaDOYSVG(lifearea) {
            //Step1: get the laDOYData:
            this.lifeAreaDOYArray = Object.entries(this.lifeAreaDOYs);
            [...this.lifeAreaDOYArray].map((aLifeArea)=>{
                if (aLifeArea[0] == lifearea) {
                    this.currentLifeAreaDOY = aLifeArea;
                }
            });
            //Step2: get the DOYKeysVals
            this.currentLifeAreaDOYKeys = this.returnDOYKeysVals(this.currentLifeAreaDOY[1]);
            this.currentLADOYPointsLayers(this.currentLifeAreaDOYKeys[this.VALS], this.currentLifeAreaDOYValsMax) ;
            this.lifeAreaSVGData =  this.createOverallFSDOYSVG2(this.currentLifeAreaDOY[1], this.currentLifeAreaDOYKeys[this.KEYS], this.currentLifeAreaDOYValsMin, this.currentLifeareaMultiplier, 'green') ;
        },


        getDOYKeysVals(data){
            var allKeys = [];
            var allVals = [];
            // console.error(data);
           data.forEach((aRow)=> {
                allKeys.push(aRow.doy);
                allVals.push(aRow.points);
            });
            this.overallFSDOYVals = allVals;
            this.overallFSDOYKeys=  allKeys;
    },
    returnDOYKeysVals(data){
        let DOYkeyVals = [];
        var allKeys = [];
        var allVals = [];
        // console.error(data);
        data.forEach((aRow)=> {
            allKeys.push(aRow.doy);
            allVals.push(aRow.points);
        });
        // console.error(allVals);
        // console.error(allKeys);
        DOYkeyVals[this.VALS] = allVals;
        DOYkeyVals[this.KEYS]=  allKeys;
        return DOYkeyVals;
    },

        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
            // // usage example:
            // var a = ['a', 1, 'a', 2, '1'];
            // var unique = a.filter(onlyUnique);
        },
        daysInYear(year) {
            return ((year % 4 === 0 && year % 100 > 0) || year %400 == 0) ? 366 : 365;
        },

        createOverallFSDOYSVG2(data, doyKeys, doysMin, pointsMultiplier, shades) {
             console.log(shades);
            // console.log(doyKeys);
            // console.log(pointsMultiplier);
            let rgb =0;
            let inc = 3
            if(shades == 'blue') {
                rgb = 1; inc = 3;
            }
            if(shades == 'green') {
                rgb = 1; inc = 4;
            }
            if(shades == 'yellow') {
                rgb = 0; inc = 3;

            }

            const d = new Date();
            let thisYear = d.getFullYear();
            var daysInYear = this.daysInYear(thisYear);

            var rects = svgbase;
            var yeardays = '';
            var loopDOY = 0;
            for(var week=1; week <=52; week++) {
                for(var day=1; day <=7; day++) {
                    var row = '';
                    var vi = day * 13 - 1;
                    var ex = week * 13 +14;
                    loopDOY += 1;
                    (loopDOY > daysInYear)? loopDOY = 1:'';

                    if (doyKeys.includes(loopDOY)) {
                        var doyPoints = this.getPointsForDOY(data, loopDOY);
                        // console.log("doyPoints: " + doyPoints);
                        // var thisColor = this.createColorForDOYPoints(doyPoints, 1, 3); //blue(y) = 1, 3; pink(y) = 1, 2; yellow(y) = 0, 3,green(y)= 1,4;red(m)=0,4;yelloworange= 1,5;
                        if(doyPoints > 0) {
                            var thisColor = this.createColorForDOYPoints2(doyPoints, doysMin, pointsMultiplier, rgb,inc)
                            // console.log("Color: " + thisColor);
                            row = `<rect x="`+ex+ `" y="`+ vi +`" width="11" height="11" rx="0" ry="0" style="fill:`+ thisColor +`;"/>`;
                            yeardays +=  row;
                        }
                    }
                }
            }
                // console.log(rects + yeardays);
            return rects + yeardays ;
        },


        createColorForDOYPoints2(doyPoints, doyValsMin, doyPointsMultiplier, rgb=0, inc) {//rgb is r=0,g=1,b=2, inc=true is 1->256,inc= 1,2,3
            // console.log("Points: "+ doyPoints);
            let comp = (doyPoints-doyValsMin) * doyPointsMultiplier;
            comp = comp>256? 256:comp;
            // console.error(comp);
            let thisRGB = '';
            if(inc==1) {
                // console.error(comp);
                if(rgb == 0)  thisRGB = "rgb(" + comp + ", 256, 256)";
                if(rgb == 1)  thisRGB = "rgb(256," + comp + ", 256)";
                if(rgb == 2)  thisRGB = "rgb(256, 256," + comp + ")";
            }
            if(inc==2) {
                comp -=256;
                // console.error(comp);
                if(rgb == 0)  thisRGB = "rgb(" +Math.abs(comp) + ", 256, 256)";
                if(rgb == 1)  thisRGB = "rgb(256," + Math.abs(comp) + ", 256)";
                if(rgb == 2)  thisRGB = "rgb(256, 256," +Math.abs(comp)+ ")";
            }
            if(inc==3) {
                comp -=256;
                // console.error(comp);
                if(rgb == 0)  thisRGB = "rgb(" +Math.abs(comp) + ", 256, 0)";
                if(rgb == 1)  thisRGB = "rgb(0," + Math.abs(comp) + ", 256)";
                if(rgb == 2)  thisRGB = "rgb(0, 256," +Math.abs(comp)+ ")";
            }
            if(inc==4) {
                comp -=256;
                // console.error(comp);
                if(rgb == 0)  thisRGB = "rgb(" +Math.abs(comp) + ", 0, 0)";
                if(rgb == 1)  thisRGB = "rgb(0," + Math.abs(comp) + ", 0)";
                if(rgb == 2)  thisRGB = "rgb(0, 0," +Math.abs(comp)+ ")";
            }
            if(inc==5) {
                comp -=256;
                // console.error(comp);
                if(rgb == 0)  thisRGB = "rgb(" +Math.abs(comp) + ", 0, 256)";
                if(rgb == 1)  thisRGB = "rgb(256," + Math.abs(comp) + ", 0)";
                if(rgb == 2)  thisRGB = "rgb(256, 0," +Math.abs(comp)+ ")";
            }
            // console.log(thisRGB);
            return  thisRGB;
        },


        componentPointsLayers() {
        if(!this.overallFSDOYVals ) console.error("overallFSDOYVals called, but overallFSDOYVals not available========");
            if(this.overallFSDOYVals) {
                //make a deep copy of overallFSDOY:
                // var deepCopyOverallFSDOY = JSON.parse(JSON.stringify(this.overallFSDOY));
                this.overallFSDOYValsMax =  Math.max(...this.overallFSDOYVals);
                this.overallFSDOYValsMin = Math.min(...this.overallFSDOYVals);
                var spread = this.overallFSDOYValsMax - this.overallFSDOYValsMin;

                //divide 256 by spread and multiply each DOY point by layerRGBPoints:
                var layerRGBPoints = Math.ceil(256/spread);
                // console.log("Max:" + this.overallFSDOYValsMax + ", Min: " + this.overallFSDOYValsMin + ", LayerSiz: " + layerRGBPoints);
                this.overallFSMultiplier = layerRGBPoints;

                //This could be where we make a Less ->More svg for display on the bottom of the svg (`a la github streak svg)
            }
        },

        currentLADOYPointsLayers(DOYdataVals) {
        if(!DOYdataVals ) console.error("DOYdataVals called, but DOYdataVals not available========");
            if(DOYdataVals) {

                //make a deep copy of overallFSDOY:
                var deepCopyDOYdata = JSON.parse(JSON.stringify(DOYdataVals));
                // console.log(deepCopyDOYdata);
                this.currentLifeAreaDOYValsMax =  Math.max(...deepCopyDOYdata);
                this.currentLifeAreaDOYValsMin = Math.min(...deepCopyDOYdata);
                var spread = this.currentLifeAreaDOYValsMax - this.currentLifeAreaDOYValsMin;

                //divide 256 by spread and multiply each DOY point by layerRGBPoints:
                var layerRGBPoints = Math.ceil(256/spread);
                // console.log("Max:" + this.currentLifeAreaDOYValsMax + ", Min: " + this.currentLifeAreaDOYValsMin + ", LayerSiz: " + layerRGBPoints);
                this.currentLifeareaMultiplier = layerRGBPoints;

                //This could be where we make a Less ->More svg for display on the bottom of the svg
                // this.
            }
        },

        generateConfig(charttype, text ) {
            var config = {
                    type: charttype,
                    options: {
                    responsive: true,
                    plugins: {
                    legend: {
                        position: 'top',
                        },
                        title: {
                            display: true,
                            text: text
                        }
                    }
                }
            };
            return config;
        },
         getMonthName(monthNum) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
                ];
            // const d = new Date();
            // document.write("The current month is " + monthNames[d.getMonth()]);
            return monthNames[monthNum-1];
        },
        displayCharts(){
            var perfdata = this.getMonthPerfData();
            var labels =  this.genLabels(perfdata);
            var monthObjs = this.getMonthsPointsArrays(perfdata);
            console.log(monthObjs);
            this.createCompositeChart(labels, monthObjs);
        },
        getMonthPerfData() {
            return Object.assign([],this.chartData.month_perf);
        },
        genLabels(data){
            var retvals = data.map((v, i, a) =>{
                 return v.lifearea;
            });
            retvals = retvals.filter(this.onlyUnique);
            // console.log(retvals);
            return retvals;
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },

        getMonthsPointsArrays(data) {
            var monthColors = ['pink', 'aqua', 'coral', 'green'];// need only 3 as 3 months in a quarter.
            //find number of months in the data:
           var monthvals =  data.map((v, i, a) =>{
                return v.month;
            });
            monthvals = monthvals.filter(this.onlyUnique);
            //  console.log(monthvals);

             var monthObjs = [];
            for(var z = 0; z<monthvals.length;z++) {
                var monthObj = {};
                monthObj.month =this.getMonthName(monthvals[z]);
                monthObj.color = monthColors[z];

                const pointsArr = [];
                for(let k = 0; k<data.length; k++){
                    if(data[k].month == monthvals[z]) pointsArr.push(data[k].points);
                }
                // console.error(pointsArr);
                monthObj.points = pointsArr;
                monthObjs.push(monthObj);
            }
            //  console.log(monthObjs);
            return monthObjs;
        },

        createCompositeChart(labels, monthObjs) {
            const datasets = monthObjs.map((monthObj)=>{
               return this.genFSDataSet('bar', monthObj.month, monthObj.points, monthObj.color);
            });
            // console.log(datasets);
            var chartInput = this.generateInput(labels, datasets);
            // console.error(chartInput);
            const ctx = document.getElementById('selfEvaluatedEffort');
            new Chart(ctx, chartInput); //hung new char on ctx
        },

        genFSDataSet(type, labelText, dataArray, bgColor = 'pink',   borderRadius = 100, borderWidth = 1, borderColor = "grey", ){
           return  {
                    label: labelText,
                    type: type,
                    data:dataArray,
                    borderColor: bgColor,
                    borderWidth: 2,
                    backgroundColor: transparentize(bgColor, 0.4),
                    borderRadius:borderRadius,
                    borderSkipped: false,
                };
        },
        generateInput(labels, datasets,) {
            //generate Data from DB-supplied data:
            var input = {};
            var data= {
            labels:labels,
            datasets:datasets
            };
            // this.generateConfig('doughnut', 'bar', data, 'Peformance for '+lifeArea);
            var options = this.generateConfig('line', 'Overall Title');

            input.data= data;
            input.type= 'bar';//is the shape command bar, doughnut,line,  etc,
            input.options= options;
            // console.error(input);
            return input;
        },

        flagCompForDOY(data, doy) {
            var hasFlag = false;
                for (const [key, value] of Object.entries(data)) {
                    if(value.doy == doy) {
                        hasFlag = true;
                    }
                }
            return hasFlag;
        },

        getPointsForDOY(data, doy) {
            var thePoints = 0;
                data.forEach((aRow)=>{
                    if(aRow.doy == doy) {
                        thePoints = aRow.points;
                    }
                });
            return thePoints;
        },
        cancel() {
            $('div#display-results-modal').modal('hide');
        },

        selectHabit(id){
            this.currenthabitdata = this.habitdata.filter((habit) => {
                return habit.id  == id;
            });
            this.currenthabitid = this.currenthabitdata[0].id;
            this.deletionsuccess = false;
            this.getHabitData(id);
        },
        disableClickedButton(compid) {
            document.getElementById(compid).disbled = true;
        },
        getHabitData(habitid) {
            if(habitid != '') {
                axios.post('/habits/tracking/getbasedata', {
                    user_id:this.userdata.id,
                    habit_id: habitid,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.habittrackingdata = JSON.parse(res.data.tracking);
                    this.componentdata = JSON.parse(res.data.components);
                    this.failure = false;
                    SwalUtil.update_toast(this.message, 4000);
                })
                .catch(err => {
                    this.loading = false;
                    this.failure = true;
                    this.success = false;
                    this.message =err.message;
                })
                .finally(() => {
                        this.$forceUpdate();
                });
            }
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },

}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
.chart-container {
position: relative;
height:30vh;
width:40vw;
    @media only screen and (max-width: 768px) {
        height:40vh;
        width:80vw;
    }
}

/* svg {
      width:  auto;
      height: auto;
} */
.svg-container {
 width: 100%;
 height: 150px;
 resize: both;
 overflow: auto;
 border: 1px dashed #aaa;
}
.bordered{
border: .5px solid rgb(193, 191, 191);
border-radius: 4px;
padding: 8px;
margin: 8px;
background: #d9e7f4;
}


svg {
@media screen {max-width: 768px;


  /* transform: rotate(45deg) rotate(-45deg); */
 /* transform: rotate(90deg) ; */
  /* transform-origin: 50% 50%; Chrome, Firefox behaves differently */
}
}
</style>
